import { EVENT_LOCATION_TYPE } from 'utils/constants/general/eventLocationType';
import { LOCATION_TYPE } from 'utils/constants/general/locationType';

export function getLocationTypeText(
  listingType: string,
  locationType: 'REMOTE' | 'HYBRID' | 'ONSITE',
) {
  if (listingType === 'EVENT') {
    return EVENT_LOCATION_TYPE[locationType];
  }
  return LOCATION_TYPE[locationType];
}
